export const getHeaders = (tipovista = "completo") => {
  const columnasExtras = {
    conCosto: [
      { field: "id", headerName: "ID", hidden: true },
      {
        field: "codigo",
        headerName: "Codigo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 70,
        cellClassName: "centered-cell",
      },
      {
        field: "descripcion",
        headerName: "Descripcion",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 250,
        cellClassName: "centered-cell",
      },
      {
        field: "preciocosto",
        headerName: "P. Costo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
    ],
    mayoristaMinorista: [
      {
        field: "preciomayorista",
        headerName: "P. Mayorista",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
      {
        field: "preciominorista",
        headerName: "P. Minorista",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
    ],
    todosPrecios: [
      { field: "id", headerName: "ID", hidden: true },
      {
        field: "codigo",
        headerName: "Codigo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 70,
        cellClassName: "centered-cell",
      },
      {
        field: "descripcion",
        headerName: "Descripcion",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 250,
        cellClassName: "centered-cell",
      },
      {
        field: "preciocosto",
        headerName: "P. Costo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
      {
        field: "preciomayorista",
        headerName: "P. Mayorista",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
      {
        field: "preciominorista",
        headerName: "P. Minorista",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
    ],
    conStock: [
      { field: "id", headerName: "ID", hidden: true },
      {
        field: "codigo",
        headerName: "Codigo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 70,
        cellClassName: "centered-cell",
      },
      {
        field: "descripcion",
        headerName: "Descripcion",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 500,
        cellClassName: "centered-cell",
      },
      {
        field: "stock",
        headerName: "Existencia",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
    ],
    completo: [
      { field: "id", headerName: "ID", hidden: true },
      {
        field: "codigo",
        headerName: "Codigo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 70,
        cellClassName: "centered-cell",
      },
      {
        field: "descripcion",
        headerName: "Descripcion",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 250,
        cellClassName: "centered-cell",
      },
      {
        field: "preciocosto",
        headerName: "P. Costo",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
      {
        field: "preciomayorista",
        headerName: "P. Mayorista",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
      {
        field: "preciominorista",
        headerName: "P. Minorista",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
      {
        field: "stock",
        headerName: "Existencia",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        minWidth: 120,
        cellClassName: "centered-cell",
      },
    ],
  };

  // Combinar columnas base + columnas según tipovista
  const extraCols = columnasExtras[tipovista] || columnasExtras["completo"];
  return [ ...extraCols];
};
